<template>
  <div>
    <a-form :form="form" :label-col="{ span: 5 }" :wrapper-col="{ span: 12 }">
      <div id="myCal">
        <!-- 保费试算 -->
        <div class="title_">
          <div class="cutleft_">保费试算</div>
          <div class="cutoff_"></div>
        </div>
        <a-row class="changeStyle_">
          <a-col :span="18">
            <div class="form_item" style="justify-content: flex-start">
              <label>保障期间</label>
              <div class="pre-box" style="margin-left: 10px">
                <div class="">
                  <a-radio-group :disabled="userBol" v-model="guapre"
                    @change="(e) => changeData(e.target.value, 'BZQJa')">
                    <a-radio v-for="item in guarantPre" :key="item.key" :value="item.key">{{ item.value }}</a-radio>
                  </a-radio-group>
                </div>
              </div>
            </div>
            <div>
              <a @click="$tools.downloadFile(fileCodeContent.occ_url)">职业类别表</a>
              <span style="color: red; margin-left: 20px">
                <a-icon type="info-circle" />&nbsp;不同职业类别需拆单投保，且需投保同一方案</span>
            </div>
            <div class="form_item">
              <label>投保职业</label>
              <div class="right_">
                <div class="check_item s_input" v-for="item in occupationNumberList" :key="item.occupationKind">
                  <label for>
                    {{ item.occupationKind }}
                  </label>
                  <a-input-number :min="0" :disabled="leibie!=item.occupationKind||userBol" v-model="item.personNum"
                    @change="(value) => changeData(value, 'TBZYa')"></a-input-number>
                  <span>人</span>
                </div>
                <div class="check_item">
                  <span>总人数：{{ totalNumber }}人</span>
                </div>
              </div>
            </div>
            <div class="form_item" style="justify-content: start">
              <label>投保人行业类型</label>
              <div class="right_">
                <a-select :disabled="userBol" placeholder="请选择行业类型" style="width: 280px" class="select_"
                  v-model="countData.HYLX" @change="(value) => changeData(value, 'HYLX')">
                  <a-select-option v-for="item in HYLXOptions" :key="item.value + 'HYLX'" :value="item.value">
                    {{ item.name }}</a-select-option>
                </a-select>
              </div>
            </div>
            <div class="form_items">
              <label>是否涉高&nbsp;&nbsp;&nbsp;</label>
              <div class="right_">
                <div class="check_item" style="margin-left: 40px">
                  <a-radio-group :disabled="userBol" name="radioGroup" :default-value="0" v-model="countData.SFSGa"
                    @change="(e) => changeData(e.target.value, 'SFSGa')">
                    <a-radio :value="2">不涉高</a-radio>
                    <a-radio :value="1">涉高</a-radio>
                  </a-radio-group>
                </div>
              </div>
            </div>
            <div class="form_item">
              <a-form-item :label-col="{ span: 7 }" label="投保人名称">
                <a-input :disabled="userBol" style="width: 280px" v-model="countData.name"
                  @change="(e) => changeData(e.target.value, 'name')" placeholder="请填写投保人名称" v-decorator="[
                    'countData.name',
                    {
                      rules: [{ required: true, message: '请输入投保人名称' }],
                    },
                  ]"></a-input>
              </a-form-item>
              <p style="margin-left: 100px;color: red;">①江苏省-苏州市-常熟市及张家港市地区的企业团体，仅限投保1-2类职业。②不承保广东江门市家具制造业。③不承保天津地址所有企业。
              </p>
            </div>
          </a-col>
          <a-col :offset="2" :span="4" class="calRight_">
            <div class="calTxt_">保费合计</div>
            <div class="calmoney_">¥ {{ premiumSum }}</div>
          </a-col>
        </a-row>
      </div>
      <div class="risk_">
        <p class="p-header">主险</p>
        <!-- 意外伤害身故、残疾 -->
        <div class="form_item">
          <label>意外伤害身故、残疾</label>
          <div class="right_">
            <a-select :disabled="userBol" placeholder="请选择" style="width: 300px" class="select_"
              @change="(value) => changeData(value, 'SWCJ')" v-model="countData.SWCJ">
              <a-select-option v-for="item in SWCJOptions" :key="item.value + 'SWCJ'" :value="item.value">
                {{ item.name }}</a-select-option>
            </a-select>
          </div>
        </div>
        <p class="p-header">附加险</p>
        <div class="flex_">
          <!-- 意外伤害医疗费用 -->
          <div class="form_item">
            <label>意外伤害医疗费用（社保范围内0元免赔100%赔付）</label>
            <div class="right_">
              <a-select :disabled="userBol" placeholder="请选择" style="width: 300px" class="select_"
                v-model="countData.YLFY" @change="(value) => changeData(value, 'YLFY')">
                <a-select-option v-for="(item, index) in YLFYOptions" :key="item.value + 'YLFY' + index"
                  :value="item.value" :disabled="item.disabled">{{ item.name }}</a-select-option>
              </a-select>
            </div>
          </div>
          <!-- 自费药费用(即保司系统自费药)（含甲乙丙类自付和自费） -->
          <div class="form_item">
            <label>扩展自费药（0免90%报）</label>
            <div class="right_">
              <a-select placeholder="请选择" style="width: 300px" class="select_" :disabled="countData.YLFY === 0||userBol"
                v-model="countData.ZFYF" @change="(value) => changeData(value, 'ZFYF')">
                <a-select-option v-for="(item, index) in ZFYFOptions" :key="item.value + 'ZFYF' + index"
                  :value="item.value">{{ item.name }}</a-select-option>
              </a-select>
            </div>
          </div>
          <!-- 意外住院津贴责任 -->
          <div class="form_item">
            <label>意外住院津贴（单次最长180天）</label>
            <div class="right_">
              <a-select :disabled="userBol" placeholder="请选择" style="width: 300px" class="select_"
                v-model="countData.ZYJT" @change="(value) => changeData(value, 'ZYJT')">
                <a-select-option v-for="item in ZYJTOptions" :key="item.value + 'ZYJT'" :value="item.value">
                  {{ item.name }}</a-select-option>
              </a-select>
            </div>
          </div>
          <!-- 客运民航客机意外身故残疾 -->
          <div class="form_item">
            <label>客运民航客机意外身故残疾</label>
            <div class="right_">
              <a-select :disabled="userBol" placeholder="请选择" style="width: 300px" class="select_"
                v-model="countData.YCXSCa" @change="(value) => changeData(value, 'YCXSCa')">
                <a-select-option v-for="item in oneSCOptions" :key="item.value + 'YCXSCa'" :value="item.value">
                  {{ item.name }}</a-select-option>
              </a-select>
            </div>
          </div>
          <!-- 客运轨道交通意外身故残疾 -->
          <div class="form_item">
            <label>客运轨道交通意外身故残疾</label>
            <div class="right_">
              <a-select :disabled="userBol" placeholder="请选择" style="width: 300px" class="select_"
                v-model="countData.SHHLa" @change="(value) => changeData(value, 'SHHLa')">
                <a-select-option v-for="item in oneSCOptions" :key="item.value + 'SHHLa'" :value="item.value">
                  {{ item.name }}</a-select-option>
              </a-select>
            </div>
          </div>
          <!-- 客运轮船意外身故残疾 -->
          <div class="form_item">
            <label>客运轮船意外身故残疾</label>
            <div class="right_">
              <a-select :disabled="userBol" placeholder="请选择" style="width: 300px" class="select_"
                v-model="countData.KYLCYW" @change="(value) => changeData(value, 'KYLCYW')">
                <a-select-option v-for="item in oneSCOptions" :key="item.value + 'KYLCYW'" :value="item.value">
                  {{ item.name }}</a-select-option>
              </a-select>
            </div>
          </div>
          <!-- 客运机动车意外身故残疾 -->
          <div class="form_item">
            <label>客运机动车意外身故残疾</label>
            <div class="right_">
              <a-select :disabled="userBol" placeholder="请选择" style="width: 300px" class="select_"
                v-model="countData.KYQCYW" @change="(value) => changeData(value, 'KYQCYW')">
                <a-select-option v-for="item in KYQCYWOptions" :key="item.value + 'KYQCYW'" :value="item.value">
                  {{ item.name }}</a-select-option>
              </a-select>
            </div>
          </div>
          <!-- 驾乘人员意外身故残疾 -->
          <div class="form_item">
            <label>驾乘人员意外身故残疾</label>
            <div class="right_">
              <a-select :disabled="userBol" placeholder="请选择" style="width: 300px" class="select_"
                v-model="countData.JCYW" @change="(value) => changeData(value, 'JCYW')">
                <a-select-option v-for="item in JCYWOptions" :key="item.value + 'JCYW'" :value="item.value">
                  {{ item.name }}</a-select-option>
              </a-select>
            </div>
          </div>
          <!-- 猝死 -->
          <div class="form_item">
            <label>猝死</label>
            <div class="right_">
              <a-select :disabled="userBol" placeholder="请选择" style="width: 300px" class="select_"
                v-model="countData.WGFY" @change="(value) => changeData(value, 'WGFY')">
                <a-select-option v-for="item in WGFYOptions" :key="item.value + 'WGFY'" :value="item.value">
                  {{ item.name }}</a-select-option>
              </a-select>
            </div>
          </div>
        </div>
        <div class="btn_list">

         <a-button style="margin-bottom:50px;" class="calBtn_" type="primary" @click="goplicy" v-if='!agreementRead'>
          完成报价，立即投保</a-button>
          <a-button class="calBtn_" type="primary" @click="countPremiumSum">刷新试算</a-button>
        </div>
      </div>
    </a-form>
  </div>
</template>

<script>
  import utils from "./../js/utils";
  import { riskinfoMixin } from '@/mixins/riskinfoMixin.js';
  export default {
  mixins: [riskinfoMixin],
    data() {
      return {
        leibie: 1,
        productCode: "",
        plan: "",
        form: this.$form.createForm(this, { name: "advanced_search" }),
        guapre: 12,
        //保障期间
        guarantPre: [
          {
            key: 1,
            value: "1个月",
          },
          {
            key: 3,
            value: "3个月",
          },
          {
            key: 6,
            value: "6个月",
          },
          {
            key: 12,
            value: "12个月",
          },
        ],

        premiumSum: 0, //总保费
        // 扩展残疾鉴定国家工伤标准
        KZSCOptions: [
          {
            value: 0,
            name: "不附加",
          },
          {
            value: 1,
            name: "附加",
          },
        ],
        // 猝死
        WGFYOptions: [
          {
            value: 0,
            name: "不附加",
          },
          {
            value: 100000,
            name: "10万",
          },
        ],
        // 飞机意外伤害身故和残疾  // 火车意外伤害身故和残疾 //轮船意外伤害身故和残疾
        oneSCOptions: utils.oneSCOptions,//汽车意外伤害身故和残疾
        KYQCYWOptions: utils.KYQCYWOptions,
        //驾乘意外
        userBol: false,// 禁止操作开关
        JCYWOptions: utils.JCYWOptions,
        HYLXOptions: [
          {
            value: 0,
            name: "其他行业",
          },
          {
            value: 1,
            name: "楼宇/土木工程",
          },
        ], //是否是建筑行业
        // 测算要提交的数据
        countData: {
          BZQJa: 12, //保障期间?
          TBZYa: 0, //投保职业?
          SFSGa: 0, //是否涉高
          HYLX: 0, //是否是建筑行业
          name: "", //投保人名称
          SWCJ: 100000, //意外伤害身故、残疾
          YLFY: 0, //意外医疗费用
          ZFYF: 0, //自费药费用
          ZYJT: 0, //意外住院津贴
          YCXSCa: 0, //飞机意外伤害身故和残疾
          SHHLa: 0, //火车意外伤害身故和残疾
          KYLCYW: 0, //轮船意外伤害身故和残疾
          KYQCYW: 0, //汽车意外伤害身故和残疾
          JCYW: 0, //驾乘意外伤害身故和残疾
          WGFY: 0, //猝死
        },
        prohibitedIndustries: [ //投保名称限制关键字
          "铁塔",
          "电梯",
          "幕墙",
          "危险品",
          "脚手架",
          "房屋",
          "拆房",
          "疏浚",
          "拆",
          "劳务",
          "钢结构",
          "人力资源",
          "职业介绍",
          "人才服务",
          "人才介绍",
          "企业咨询"
        ],
        //提交data
        data: {
          architecture: 0, //是否是建筑行业
          riskInfos: [],
          salPolicy: {
            productCode: "", //产品code
            bracket: 12, //保费期限
            planCode: "",
          },
          salPolicyHolder: {
            addfifty: "1", // 测算类型
            stature: 0, //是否高空（0-否，1-是）
          },
          premiumBaseDtoList: [], //人数
        },
        planType: "A",
        occupationNumberList: [
          {
            occupationKind: "1类",
            personNum: 0,
          },
          {
            occupationKind: "2类",
            personNum: 0,
          },
          {
            occupationKind: "3类",
            personNum: 0,
          },
          {
            occupationKind: "4类",
            personNum: 0,
          },
          {
            occupationKind: "5类",
            personNum: 0,
          },
        ]
      };
    },
    computed: {
      // 意外伤害身故、残疾
      SWCJOptions() {
        let Options = utils.SWCJOptions
        if (this.countData.SFSGa == 1) {//涉高
          return Options.filter((item) => item.value <= 500000);
        }
        if (this.leibie == '5类') {
          //5类
          return Options.filter((item) => item.value <= 500000);
        }
        if (this.leibie == '4类') {
          //4类
          return Options.filter((item) => item.value <= 600000);
        } else {
          return Options;
        }
      },
      // 扩展社保范围外医疗费用（含甲乙丙类自付和自费）
      ZFYFOptions() {
        let Options = [
          //自费药费用(即保司系统自费药)选择框
          {
            value: 0,
            name: "不附加",
          },
          {
            value: 0.1,
            name: "意外医疗费用保额的10%",
          },
          {
            value: 0.2,
            name: "意外医疗费用保额的20%",
          },
        ];
        return Options;
      },
      // 意外伤害医疗费用
      YLFYOptions() {
        let option = utils.YLFYOptions
        let SWCJ = this.countData.SWCJ;// 主险保额
        if (this.leibie == '4类' || this.leibie == '5类' || this.countData.SFSGa == 1) {
          return option.filter((item) => item.value <= SWCJ * 0.1);
        } else {
          return option.filter((item) => item.value <= SWCJ * 0.2);
        }
      },
      // 意外住院津贴
      ZYJTOptions() {
        let ZYJTOptions = [
          //意外住院津贴责任 : ZYJT
          {
            value: 0,
            name: "不附加",
          },
          {
            value: 50,
            name: "50元/天",
          },
          {
            value: 100,
            name: "100元/天",
          },
          {
            value: 150,
            name: "150元/天",
          },
          {
            value: 200,
            name: "200元/天",
          },
        ];
        if (this.leibie == '4类' || this.leibie == '5类' || this.countData.SFSGa == 1) {
          return ZYJTOptions.filter((item) => item.value <= 100);
        }
        return ZYJTOptions;
      },
      // 选的总投保人数
      totalNumber() {
        let num = 0;
        this.occupationNumberList.forEach((e) => {
          num += Number(e.personNum);
        });
        return parseInt(num);
      },
      // 险种的数组
      riskInfos() {
        let infos = [
          {
            riskCode: "PL180Y502", //意外伤害身故、残疾
            dutyCode: "CVYA001",
            amount: this.countData.SWCJ,
            premiumAmt: 0,
            riskName: `意外伤害身故、残疾`,
            riskAmountDesc: this.countData.SWCJ
          },
          {
            riskCode: "PL180J003", //意外医疗费用补偿
            dutyCode: "CVJA017",
            amount: this.countData.YLFY,
            riskName: `意外伤害医疗费用`,
            premiumAmt: 0,
            riskAmountDesc: this.countData.YLFY
          },
          {
            riskCode: "PL180J128", //自费药费用
            dutyCode: "CVJA043",
            amount: this.countData.ZFYF * this.countData.YLFY,
            premiumAmt: 0,
            riskName: `扩展自费药`,
            riskAmountDesc: this.countData.ZFYF == '0.1' ? '意外医疗费用保额的10%' : '意外医疗费用保额的20%'
          },
          {
            riskCode: "PL180J092", //意外伤害住院津贴
            dutyCode: "CVJD006",
            amount: this.countData.ZYJT * 180,
            premiumAmt: 0,
            riskName: `意外伤害住院津贴`,
            riskAmountDesc: `${this.countData.ZYJT}元/天`
          },
          {
            riskCode: "PL180Y504", //客运民航客机意外身故残疾
            dutyCode: "CVYA008",
            amount: this.countData.YCXSCa,
            premiumAmt: 0,
            riskName: `客运民航客机意外身故残疾`,
            riskAmountDesc: this.countData.YCXSCa
          },
          {
            riskCode: "PL180Y504", //客运轨道交通意外身故残疾
            dutyCode: "CVYA009",
            amount: this.countData.SHHLa,
            premiumAmt: 0,
            riskName: `客运轨道交通意外身故残疾`,
            riskAmountDesc: this.countData.SHHLa
          },
          {
            riskCode: "PL180Y504", //客运轮船意外身故残疾
            dutyCode: "CVYA010",
            amount: this.countData.KYLCYW,
            premiumAmt: 0,
            riskName: `客运轮船意外身故残疾`,
            riskAmountDesc: this.countData.KYLCYW
          },
          {
            riskCode: "PL180Y504", //客运机动车意外身故残疾
            dutyCode: "CVYA011",
            amount: this.countData.KYQCYW,
            premiumAmt: 0,
            riskName: `客运机动车意外身故残疾`,
            riskAmountDesc: this.countData.KYQCYW
          },
          {
            riskCode: "PL180Y598", //驾乘人员意外身故残疾
            dutyCode: "CVYA001",
            amount: this.countData.JCYW,
            premiumAmt: 0,
            riskName: `驾乘人员意外身故残疾`,
            riskAmountDesc: this.countData.JCYW
          },
          {
            riskCode: "PL180J103", //猝死
            dutyCode: "CVJB009",
            amount: this.countData.WGFY,
            premiumAmt: 0,
            riskName: `猝死`,
            riskAmountDesc: this.countData.WGFY
          },
        ];
        return infos;
      },
    },
    watch: {
      "countData.YLFY"(val) {
        if (!val) {
          this.countData.ZFYF = 0;
        }
      },
      "countData.name"(val) {
        this.prohibitedIndustries.forEach((element) => {
          if (val.indexOf(element) != -1) {
            this.countData.name = ''
            this.form.setFieldsValue({
              countData: {
                name: ''
              }
            })
           this.$message.warning(
          "投保人名称中含以下关键字的企业团体拒保：拆、拆房、房屋、疏浚、脚手架、危险品、幕墙、电梯、铁塔、劳务、钢结构、人力资源、职业介绍、人才服务、人才介绍、企业咨询，不在方案承保范围"
        );
            return;
          }
        });
        if (val.indexOf('天津') != -1) {
          this.countData.name = ''
          this.form.setFieldsValue({
            countData: {
              name: ''
            }
          })
          this.$message.warning("天津地区企业不可投保");
        }
        if (this.leibie == '3类' || this.leibie == '4类' || this.leibie == '5类') {
          if (val.indexOf('张家港') != -1 || val.indexOf('常熟') != -1) {
            this.countData.name = ''
            this.form.setFieldsValue({
              countData: {
                name: ''
              }
            })
            this.$message.warning("该投保人企业不符合投保规则, 不可投保");
          }
        }
      },
      "countData.HYLX"(val) {
        if (val != 1) {
          this.countData.SFSGa = 2;
        }
      },
    },
    created() {
      const {  p, planCode } = this.$route.query;
      this.productCode = p;
      if (planCode) {
        this.leibie = parseFloat(planCode.split('jybzxttyw')[1]).toString() + '类'
      } else {
        this.leibie = '1类'
      }
      this.plan = planCode;
      if (this.$route.query.policyId) {
        this.userBol = true;
      } else {
        this.userBol = false;
      }
     this.$store.commit('setagreementRead', this.userBol)
      if (this.$route.query.xb) {
        this.userBol = false;
      }
    },
    mounted() {
      this.$bus.$on('busUserBol', () => {
        this.userBol = false
      })
      this.$bus.$on('busStature', (data) => { //涉高
        this.countData.SFSGa = data - 0
      })
      this.$bus.$on('busRiskInfos', (data) => { //险种信息 附指   保单详情中的险种信息
        let obj = this.$lodash.cloneDeep(this.countData)
        data.forEach(e => {
          if (e.riskCode == 'PL180Y502' && e.dutyCode == "CVYA001") obj.SWCJ = e.riskAmountDesc - 0
          if (e.riskCode == 'PL180J003' && e.dutyCode == "CVJA017") obj.YLFY = e.riskAmountDesc - 0
          if (e.riskCode == 'PL180J128' && e.dutyCode == "CVJA043") obj.ZFYF = e.riskAmountDesc == '意外医疗费用保额的10%' ? 0.1 : 0.2
          if (e.riskCode == 'PL180J092' && e.dutyCode == "CVJD006") obj.ZYJT = e.riskAmountDesc.split('元/天')[0] - 0
          if (e.riskCode == 'PL180Y504' && e.dutyCode == "CVYA008") obj.YCXSCa = e.riskAmountDesc - 0
          if (e.riskCode == 'PL180Y504' && e.dutyCode == "CVYA009") obj.SHHLa = e.riskAmountDesc - 0
          if (e.riskCode == 'PL180Y504' && e.dutyCode == "CVYA010") obj.KYLCYW = e.riskAmountDesc - 0
          if (e.riskCode == 'PL180Y504' && e.dutyCode == "CVYA011") obj.KYQCYW = e.riskAmountDesc - 0
          if (e.riskCode == 'PL180Y598' && e.dutyCode == "CVYA001") obj.JCYW = e.riskAmountDesc - 0
          if (e.riskCode == 'PL180J103' && e.dutyCode == "CVJB009") obj.WGFY = e.riskAmountDesc - 0
        });
        console.log(obj)
        this.countData = { ...obj }
      })
    },
    beforeDestroy() {
      this.$bus.$off("busUserBol");
      this.$bus.$off("busRiskInfos");
    },
    methods: { // 去投保
      goplicy() {
        this.$store.commit('setAgreement', true)
      },
      // 改变试算的数据
      changeData(value, param) {
        if (param == 'name') {
          this.prohibitedIndustries.forEach((element) => {
            if (value.indexOf(element) != -1) {
              return;
            }
          });
          if (value.indexOf('天津') != -1) {
            return
          }
          if (this.leibie == '3类' || this.leibie == '4类' || this.leibie == '5类') {
            if (value.indexOf('张家港') != -1 || value.indexOf('常熟') != -1) {
              return
            }
          }
        }
        if (param == 'SFSGa') {
          this.countData.YLFY = 0
          this.countData.ZYJT = 0
          this.form.setFieldsValue({
            countData: {
              YLFY: 0,
              ZYJT: 0
            }
          })
        }
        this.countData[param] = value;
        this.data = {
          architecture: this.countData.HYLX.toString(), //是否是建筑行业，1建筑行业，0其他行业
          riskInfos: this.riskInfos, //险种信息
          salPolicy: {
            productCode: this.productCode, //产品code
            bracket: this.countData.BZQJa.toString(), //保费期限
            planCode: this.plan,
          },
          salPolicyHolder: {
            addfifty: "1", // 测算类型
            name: this.countData.name,
            stature: this.countData.SFSGa.toString(), //是否高空（2-否，1-是）
          },
          premiumBaseDtoList: this.occupationNumberList.filter(
            (item) => item.personNum > 0
          ), //人数
          // premiumBaseDtoList: this.occupationNumberList, //人数
        };
        let arrData = this.$lodash.cloneDeep(this.data);
        delete arrData["premiumBaseDtoList"]; //投保职业人数是不参与下面的计算的
        if (param != "TBZYa") {
          console.log(arrData, "开始传数据");
          this.$bus.$emit("onRiskInfos", arrData);
        }
      },
      //测算的总价格
      cesuannum(data) {
        var a = {};
        var resultnum = 0;
        this.data.premiumBaseDtoList.forEach((e) => {
          a[e.occupationKind] = e.personNum;
        });
        for (const key in a) {
          resultnum += a[key] * data[key];
        }
        console.log("总保费===>", resultnum);
        return resultnum.toFixed(2);
      },
      //保费试算
      countPremiumSum(e) {
        e.preventDefault();
        this.data.salPolicyHolder.addfifty = "1";
        this.form.validateFields((err) => {
          if (!err) {
            console.log(this.data, "改变试算要提交的数据");
            if (!this.totalNumber) {
              this.premiumSum = 0;
              this.$message.warning("请选择投保人数");
              return;
            }
            if (this.leibie == "4类" || this.leibie == "5类") {
              if (this.totalNumber<10) {
                this.$message.warning(
                  "4-5类职业最低投保人数最低10人。"
                );
                return
              }
            }
            this.$api.calPremiumEmployer(this.data).then((res) => {
              if (res.data.success) {
                let data = res.data.content;
                this.premiumSum = this.cesuannum(data);
                console.log(this.premiumSum, "计算出来的总保费");
              } else {
                this.$message.error(res.data.returnMsg + "错误");
              }
            });
          }
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
  .calTxt_ {
    font-size: 18px !important;
    font-weight: bold !important;
    color: #666666;
  }

  .pre-box {
    margin-top: 15px;
  }

  .form_items {
    display: flex;
    width: 100%;
    color: #333;
    margin-bottom: 10px;
  }

  .risk_ {
    width: 60%;
  }

  .btn_list {
    margin-top: 20px;
    display: flex;

    .calBtn_ {
      margin-right: 30px;
    }
  }

  .flex_ {
    display: flex;
    flex-wrap: wrap;
  }

  .form_item {
    display: flex;
    justify-content: space-between;
    width: 100%;
    color: #333;
    margin-bottom: 10px;

    &.width_50 {
      width: 50%;
    }

    &.width_40 {
      width: 40%;
    }

    &.width_60 {
      width: 60%;
    }

    >label {
      white-space: nowrap;
      margin-right: 10px;
      margin-top: 15px;
    }

    .right_ {
      display: flex;
      flex-wrap: wrap;
      align-content: flex-start;

      .select_ {
        margin-top: 10px;
      }

      .check_item {
        display: flex;
        align-items: center;
        margin-right: 10px;
        margin-top: 10px;

        &.on {
          label {
            border-color: #fe8f2d;
          }
        }

        label {
          // border: 1px solid #d9d9d9;
          padding: 3px 10px;
          border-radius: 3px;
          margin-right: 5px;
        }

        &.s_input input {
          width: 50px;
        }

        input {
          width: 150px;
          margin-right: 5px;
        }
      }
    }
  }

  .p-header {
    width: 100%;
    font-weight: bold;
    font-size: 15px;
    margin-bottom: 0;
  }
</style>